import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from 'react-tippy';

class SaleOrRent extends React.PureComponent {
  render() {
    return (
      <div className={this.props.className}>
        {this.props.name && <span className="pr-10">{this.props.name}</span>}

        <Tooltip
          title="Venta"
          position="bottom"
          trigger="mouseenter"
        >
          <i
            className={`fa pr-5 fa-${['sale', 'both'].indexOf(this.props.value) > -1 ? 'check green-icon' : 'times red-icon'}`}
          />
        </Tooltip>
        <Tooltip
          title="Arriendo"
          position="bottom"
          trigger="mouseenter"
        >
          <i
            className={`fa fa-${['rent', 'both'].indexOf(this.props.value) > -1 ? 'check green-icon' : 'times red-icon'}`}
          />
        </Tooltip>

      </div>
    );
  }
}

SaleOrRent.propTypes = {
  name: PropTypes.string,
  value: PropTypes.string,
  className: PropTypes.string,
};

SaleOrRent.defaultProps = {
  name: '',
  value: '',
  className: '',
};

export default SaleOrRent;



// WEBPACK FOOTER //
// ./src/components/SaleOrRent/index.js